import { render, staticRenderFns } from "./LoanPerformanceTotalSearchBar.vue?vue&type=template&id=1276e8a3&"
import script from "./LoanPerformanceTotalSearchBar.vue?vue&type=script&lang=js&"
export * from "./LoanPerformanceTotalSearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports